// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u3je","tabsBox":"styles_tabsBox__1f_JP","createButton":"styles_createButton__2dm0N"};